export const LANDING_PAGE_ROUTE_PATH = "hello";
export const DEF_PUBLIC_PAGE = LANDING_PAGE_ROUTE_PATH;
export const DEF_AUTHORISED_PAGE = "projects";
